class sourceErrorListCtrl {
  constructor($scope, httpRequest, $state) {
    $scope.search = {
      pageNum: 1,
      pageSize: 10,
      totalItems: 0,
      param: {
        applyDate: '',
        endApplyDate: '',
        billBatchNoOrCode: '',
        billSource: '',
        custNameOrCreditCode: '',
        invoiceNature: '',
        invoiceType: '',
        matName: '',
      },
    }
    $scope.reset = function () {
      $scope.search.param = {
        applyDate: '',
        endApplyDate: '',
        billBatchNoOrCode: '',
        billSource: '',
        custNameOrCreditCode: '',
        invoiceNature: '',
        invoiceType: '',
        matName: '',
      }
    }
    // $scope.reset()
    function init() {
      const typecodeArrStr = '["inv_type","invoice_nature"]'
      httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
        $scope.dictData = Object.assign($scope.dictData, res.data.value)
      })
      $scope.queryInfo()
    }

    $scope.queryInfo = function queryInfo() {
      httpRequest.post_getPageSourceList($scope.search).then((res) => {
        $scope.listData = res.data.value.list
        $scope.search.totalItems = res.data.value.total
      })
    }

    $scope.tableDropdownConfig = [
      {
        label: '详情',
        handler(item) {
          const url = $state.href(
            'outputManage.FOManage.sourceError.detail',
            {
              billId: item.billId,
            },
            { reload: true }
          )
          window.open(url, '_blank')
        },
        showWhile() {
          return true
        },
      },
    ]
    init()
  }
}
sourceErrorListCtrl.$inject = ['$scope', 'httpRequest', '$state']
export default sourceErrorListCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/sourceError/sourceErrorListCtrl.js